import * as types from './mutation-types'
import { getUnites } from '../../../api/unite'

const getInitialState = () => {
  return {
    unites: {}
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_UNTIES](state, unites) {
    state.unites = unites
  }
}

const actions = {
  async setUnites({ commit }) {
    const unites = await getUnites()
    commit(types.SET_UNTIES, unites)
  }
}

const getters = {
  unites: state => state.unites
}

export default { state, mutations, actions, getters }
